import { render, staticRenderFns } from "./selectWord.vue?vue&type=template&id=d35ac746&scoped=true&"
import script from "./selectWord.vue?vue&type=script&lang=js&"
export * from "./selectWord.vue?vue&type=script&lang=js&"
import style0 from "./selectWord.vue?vue&type=style&index=0&id=d35ac746&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35ac746",
  null
  
)

export default component.exports